module.exports = __webpack_public_path__ + "static/media/7.496a882c.jpg";